import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { runTask } from 'ember-lifeline';
import { cached } from 'tracked-toolbox';
import { v4 as uuid } from 'uuid';

interface SlideToggleSignature {
  Args: {
    id?: string;
    isChecked?: boolean;
    isDisabled?: boolean;
    onClick: (checked: boolean) => unknown;
  };
  Element: HTMLLabelElement;
}

export default class SlideToggle extends Component<SlideToggleSignature> {
  @cached
  get id(): string {
    return this.args.id ?? uuid();
  }

  @action
  handleKeyUp(event: KeyboardEvent): void {
    if (event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      event.stopImmediatePropagation();
      const input = <HTMLInputElement>document.getElementById(this.id);
      const toggled = !input.checked;
      this.args.onClick(toggled);
    }
  }

  @action
  toggle(event: Event): void {
    event.preventDefault();
    runTask(this, () => this.args.onClick(!this.args.isChecked));
  }

  <template>
    <label
      class="toggle"
      tabindex="0"
      {{on "keyup" this.handleKeyUp}}
      aria-label={{concat (if @isChecked "Disable" "Enable") " with spacebar"}}
      data-test-slide-toggle-label
      ...attributes
    >
      <input
        id={{this.id}}
        disabled={{@isDisabled}}
        type="checkbox"
        checked={{@isChecked}}
        {{on "click" this.toggle}}
        data-test-slide-toggle
      />
      <span></span>
    </label>
  </template>
}
